"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const executeCommand_1 = require("../executeCommand");
const addRemoveNonUpdatedStates_1 = require("../helpers/addRemoveNonUpdatedStates");
const validateUser_1 = require("../helpers/validateUser");
const command_1 = require("../type/command");
const ExecuteAssignMutation_1 = require("./ExecuteAssignMutation");
const ExecuteForCompleteResetProgressMutation_1 = require("./ExecuteForCompleteResetProgressMutation");
const ExecuteRegularMutations_1 = require("./ExecuteRegularMutations");
const ExecuteSwitchContentMutation_1 = require("./ExecuteSwitchContentMutation");
const ExecuteUpdateContentMutation_1 = require("./ExecuteUpdateContentMutation");
function executeMutation(command, user, content, allParentContents, childContents, states, enrolments, stateInteractions) {
    validateUser_1.validateUser(user, { command, caller: 'executeMutation' });
    let mutationPayload;
    let allStates = states;
    let nonExistingDummyStates = [];
    const peerReviewCommandWithNotToEvaluate = command.type === command_1.CommandType.PEER_REVIEW && command.toEvaluate === false;
    if (!peerReviewCommandWithNotToEvaluate) {
        const allContents = [...childContents, ...allParentContents, content];
        nonExistingDummyStates = addRemoveNonUpdatedStates_1.getDummyNonExistingStatesWithVersions(command, states, allContents, user);
        allStates = states.concat(nonExistingDummyStates);
    }
    switch (command.type) {
        case command_1.CommandType.UPDATE_CONTENT:
            mutationPayload = ExecuteUpdateContentMutation_1.ExecuteUpdateContentMutation(command, user, content, allParentContents, childContents, allStates, enrolments, stateInteractions);
            break;
        case command_1.CommandType.ASSIGN_CONTENT: {
            mutationPayload = ExecuteAssignMutation_1.ExecuteAssignMutation(command, user, content, childContents, allStates, enrolments, stateInteractions);
            break;
        }
        case command_1.CommandType.SWITCH_TO_LATEST_CONTENT:
            mutationPayload = ExecuteSwitchContentMutation_1.ExecuteSwitchContentMutation(command, user, content, allParentContents, childContents, allStates, enrolments, stateInteractions);
            break;
        case command_1.CommandType.RESET_PROGRESS:
        case command_1.CommandType.FORCE_COMPLETE:
            mutationPayload = ExecuteForCompleteResetProgressMutation_1.ExecuteForceCompleteResetProgressMutation(command, user, content, allParentContents, childContents, allStates, enrolments, stateInteractions);
            break;
        case command_1.CommandType.PEER_REVIEW: {
            const { toEvaluate = true } = command;
            if (toEvaluate) {
                mutationPayload = ExecuteRegularMutations_1.ExecuteRegularMutations(command, user, content, allParentContents, childContents, allStates, enrolments, stateInteractions);
            }
            else {
                mutationPayload = executeCommand_1.executeCommand(command, user, content, childContents, allStates, enrolments, stateInteractions);
            }
            break;
        }
        case command_1.CommandType.DEASSIGN_CONTENT:
        case command_1.CommandType.CHANGE_DUE_DATE:
        case command_1.CommandType.TEACHER_FEEDBACK:
        case command_1.CommandType.REMOVE_TEACHER_FEEDBACK:
            mutationPayload = executeCommand_1.executeCommand(command, user, content, childContents, allStates, enrolments, stateInteractions);
            break;
        default:
            mutationPayload = ExecuteRegularMutations_1.ExecuteRegularMutations(command, user, content, allParentContents, childContents, allStates, enrolments, stateInteractions);
            break;
    }
    if (!peerReviewCommandWithNotToEvaluate) {
        mutationPayload.states = addRemoveNonUpdatedStates_1.filterNonUpdatedDummyStates(mutationPayload.states, nonExistingDummyStates);
    }
    return mutationPayload;
}
exports.executeMutation = executeMutation;
//# sourceMappingURL=index.js.map